// Read authenticated multipart video without one HTTP request per frame.
export async function readMjpeg(response, onFrame) {
  const reader = response.body.getReader();
  let buffer = new Uint8Array(0);
  let expected = null;
  try {
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      const merged = new Uint8Array(buffer.length + value.length);
      merged.set(buffer);
      merged.set(value, buffer.length);
      buffer = merged;
      let latest = null;
      while (buffer.length) {
        if (expected === null) {
          let end = -1;
          for (let i = 0; i < buffer.length - 3; i += 1) {
            if (buffer[i] === 13 && buffer[i + 1] === 10 && buffer[i + 2] === 13 && buffer[i + 3] === 10) {
              end = i;
              break;
            }
          }
          if (end < 0) {
            if (buffer.length > 8192) throw new Error('Cabeçalho de vídeo inválido.');
            break;
          }
          if (end > 8192) throw new Error('Cabeçalho de vídeo inválido.');
          const header = String.fromCharCode(...buffer.subarray(0, end));
          const match = header.match(/Content-Length:\s*(\d+)/i);
          expected = match ? Number(match[1]) : 0;
          if (expected <= 0 || expected > 2 * 1024 * 1024) throw new Error('Quadro de vídeo inválido.');
          buffer = buffer.subarray(end + 4);
        }
        if (buffer.length < expected) break;
        latest = new Blob([buffer.slice(0, expected)], { type: 'image/jpeg' });
        buffer = buffer.subarray(expected);
        expected = null;
      }
      // A slow connection can deliver multiple frames together. Display the newest.
      if (latest) onFrame(latest);
    }
  } finally {
    await reader.cancel().catch(() => {});
    reader.releaseLock();
  }
}
